import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry, Sentry } from "@/lib/sentry";

initSentry();

// Friendly fallback instead of a blank white screen when a render error escapes.
// The error itself is reported to Sentry (when configured) by the boundary.
function ErrorFallback() {
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        fontFamily: "Arial, Helvetica, sans-serif",
        textAlign: "center",
      }}
    >
      <div>
        <h1 style={{ color: "#373A45", fontSize: "22px", margin: "0 0 8px" }}>
          A apărut o eroare neașteptată
        </h1>
        <p style={{ color: "#6B7280", margin: "0 0 16px" }}>
          Te rugăm să reîncarci pagina. Dacă problema persistă, scrie-ne la contact@fped.org.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: "#965EA7",
            color: "#fff",
            border: "none",
            borderRadius: "9999px",
            padding: "10px 22px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Reîncarcă pagina
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
